'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useEffect } from 'react';
import ThemeToggle from '../ui/ThemeToggle';
import styles from './MobileMenu.module.scss';
import { useParams } from 'next/navigation';
const MobileMenu = t0 => {
  const $ = _c(35);
  const {
    isVisiable,
    navigation,
    dictionary,
    otherLanguages,
    onClick
  } = t0;
  const {
    lang
  } = useParams();
  let t1;
  let t2;
  if ($[0] !== isVisiable) {
    t1 = () => {
      document.body.style.overflowY = isVisiable ? "hidden" : "";
    };
    t2 = [isVisiable];
    $[0] = isVisiable;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = isVisiable ? "visiable" : "hide";
  let t4;
  if ($[3] !== lang || $[4] !== navigation.menu || $[5] !== onClick) {
    t4 = navigation.menu?.map((item, index) => <li key={"mobileMenu" + index} className={styles.item}><Link href={`${lang === "fa" ? "" : `/${lang}`}/${item.link}`} prefetch={false} className={styles.item__link} onClick={onClick}>{item.title}</Link></li>);
    $[3] = lang;
    $[4] = navigation.menu;
    $[5] = onClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <section><ul>{t4}</ul></section>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== dictionary.theme) {
    t6 = <span>{dictionary.theme}</span>;
    $[9] = dictionary.theme;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ThemeToggle type="switch" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <li key="theme" className={styles.item}>{t6}{t7}</li>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== dictionary.language) {
    t9 = <span>{dictionary.language}</span>;
    $[14] = dictionary.language;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== lang || $[17] !== otherLanguages) {
    let t11;
    if ($[19] !== lang) {
      t11 = t12 => {
        const {
          name,
          locale
        } = t12;
        if (name) {
          return <li key={locale} className={styles.languageLabel}><Link className={styles.languageLabel__link} href={`/${locale || ""}`} prefetch={false} shallow={lang === "fa"}>{name}</Link></li>;
        }
      };
      $[19] = lang;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    t10 = otherLanguages.map(t11);
    $[16] = lang;
    $[17] = otherLanguages;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <ul className={styles.languagesMenu}>{t10}</ul>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = <li key="language" className={styles.item}>{t9}{t11}</li>;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t8) {
    t13 = <section className={styles.settings}><ul className={styles.settingsMenu}>{t8}{t12}</ul></section>;
    $[26] = t12;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t5) {
    t14 = <nav className={styles.nav}>{t5}{t13}</nav>;
    $[29] = t13;
    $[30] = t5;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t3) {
    t15 = <><dialog className={styles.mobileMenu} data-state={t3}>{t14}</dialog></>;
    $[32] = t14;
    $[33] = t3;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
export default MobileMenu;